import type { RouteObject } from 'react-router-dom';
import { ReleasedFeature } from '../../release';
import { SupportPage } from '../support/SupportPage';
import { MonitoringPanelPage } from './MonitoringPanelPage';

/** The header's System Health Status (Monitoring Panel) and Support. */
export const healthRoutes: RouteObject[] = [
  {
    path: 'support',
    element: (
      <ReleasedFeature name="support-page" page>
        <SupportPage />
      </ReleasedFeature>
    ),
  },
  {
    path: 'system-health',
    element: (
      <ReleasedFeature name="system-health" page>
        <MonitoringPanelPage />
      </ReleasedFeature>
    ),
  },
];
